import { render, staticRenderFns } from "./CreateTemplate.vue?vue&type=template&id=4595423b&"
import script from "./CreateTemplate.vue?vue&type=script&lang=ts&"
export * from "./CreateTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports